import Head from '@/components/layout/Head';

const Impressum = () => {
  return (
    <>
      <Head
        title="Impressum - PayPal Gebührenrechner | paycal.org"
        description="Impressum und rechtliche Informationen des PayPal Gebührenrechners. Hier finden Sie alle relevanten Kontakt- und Unternehmensinformationen."
        canonical="https://paycal.org/impressum"
      />
      <div className="container mx-auto px-4 py-8">
        <article className="prose max-w-none">
          <h1>Impressum</h1>
          
          <h2>Angaben gemäß § 5 TMG</h2>
          <p>
            [Unternehmensname]<br />
            [Straße Nr.]<br />
            [PLZ Stadt]
          </p>

          <h2>Kontakt</h2>
          <p>
            Telefon: [Ihre Telefonnummer]<br />
            E-Mail: [Ihre E-Mail-Adresse]
          </p>

          <h2>Vertreten durch</h2>
          <p>[Name des Geschäftsführers/Inhabers]</p>

          <h2>Registereintrag</h2>
          <p>
            Eintragung im Handelsregister.<br />
            Registergericht: [Stadt]<br />
            Registernummer: [Nummer]
          </p>

          <h2>Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
            [Ihre USt-IdNr.]
          </p>

          <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p>
            [Name]<br />
            [Straße Nr.]<br />
            [PLZ Stadt]
          </p>
        </article>
      </div>
    </>
  );
};

export default Impressum;